<template>
  <div class="container p-4 mx-auto">
    <AlertLayout title="Reminders!"
      message="Kindly search for donor using either national ID number, phone number or email address of the donor. Use only one criterion at a time. Only registered donors who have ever donated at your facility will be found by the search. Non-registered donors should be registered first. Register new donor here Non-registered donations should be registered first. Register new donation here"
      type="warning" class="mb-4" />

    <div class="flex justify-end mb-4 space-x-2">

      <button class="px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-orange-600"
        @click="redirectToVitalsForm">
        + New Donation
      </button>

      <!-- <button v-if="donor && donor.blood_donations && donor.blood_donations.length > 0"
        class="px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-orange-600"
        @click="redirectToDonationReactionForm">
        + New Reaction
      </button> -->

      <button class="px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-orange-600"
        @click="redirectToDeferralForm">
        + New Deferral
      </button>

      <button class="px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-orange-600"
        @click="openReferralPopup">
        + New Referral
      </button>
    </div>

    <div class="p-10 bg-white border border-t-0 rounded-lg shadow-md">
      <h2 class="mb-2 text-xl font-bold">Donor Information</h2>

      <div v-if="donor" class="p-6 mb-6 rounded-lg bg-gray-10">
        <div class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Name:</label>
              <p v-if="donor && donor.user" class="mt-3 text-sm font-semibold">
                {{ donor?.user?.first_name }} {{ donor?.user?.last_name }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">National ID number:</label>
              <p class="mt-3 text-sm font-semibold">{{ donor.user?.id_number }}</p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Donor code:</label>
              <p class="mt-3 text-sm font-semibold">{{ donor.donor_code ?? '' }}</p>
            </div>
            <div v-if="donor.assigned_number" class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Assigned Number:</label>
              <p class="mt-3 text-sm font-semibold">{{ donor.assigned_number }}</p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Phone Number:</label>
              <p class="mt-3 text-sm font-semibold">
                {{ donor.user?.phone_number }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Email:</label>
              <p class="mt-3 text-sm font-semibold">{{ donor.user?.email }}</p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Donor date of birth:</label>
              <p class="mt-3 text-sm font-semibold">{{ donor.user?.dob }}</p>
            </div>            
          </div>
          <!-- Right Column -->
          <div class="space-y-6">
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Blood Group:</label>
              <p class="mt-3 text-sm font-semibold">
                {{ donor.user?.blood_group_id?.description ?? "" }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Last donation date:</label>
              <p class="mt-3 text-sm font-semibold">
                {{
                  donor.blood_donations && donor.blood_donations.length > 0
                    ? donor.blood_donations[0].date_added
                    : "Unknown"
                }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Last donation center:</label>
              <p class="mt-3 text-sm font-semibold">
                {{
                  donor.blood_donations && donor.blood_donations.length > 0
                    ? donor.blood_donations[0].facility_id.name
                    : "Unknown"
                }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Next donation date:</label>
              <p class="mt-3 text-sm font-semibold">
                {{
                  donor.blood_donations && donor.blood_donations.length > 0
                    ? donor.blood_donations[0].next_donation_date
                    : "Unknown"
                }}
              </p>
            </div>
            <div class="grid items-center grid-cols-2 m-2 border-t">
              <label class="mt-3 text-sm font-normal">Donor registration date:</label>
              <p class="mt-3 text-sm font-semibold">
                {{ new Date(donor.created_at).toLocaleString() ?? '' }}
              </p>
            </div>
          </div>
        </div>
        <!-- edit button -->
        <div class="flex justify-end mt-4">
          <button class="flex justify-end px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-red-600"
            @click="handleEditDonorInfo">
            Edit
          </button>
        </div>
      </div>
      <div v-else>Loading donor details...</div>



      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Donation History</h2>
        <div v-if="
          donor && donor.blood_donations && donor.blood_donations.length > 0
        " class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Date Donated
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Pint Serial
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Type of Donation
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Technology
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Anticoagulants
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Anticoagulant Volume (ml)
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Apheresis Device
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Donor Attendant
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Donated To
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Next Donation Date
                </th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">
                  Post-Donation Vitals
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(donation, index) in sortedDonations" :key="index">
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.date_added ? new Date(donation.date_added).toLocaleDateString() : '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.pint_serial || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.donation_type }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.technology }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.anticoagulants || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.technology === 'Apheresis' ? (donation.anticoagulant_volume || '') : '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.technology === 'Apheresis' ? getCollectionDeviceName(donation) : '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation?.added_by?.first_name }} {{
                  donation?.added_by?.last_name }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation?.ipop ?? '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ donation.next_donation_date ?? '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ getPostDonationVitals(donation) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="
          donor &&
          (!donor.blood_donations || donor.blood_donations.length === 0)
        ">
          No donation history available.
        </div>
        <div v-else>Loading Donation History details...</div>
      </div>

      <!-- Disposables Section -->
      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Disposables Used</h2>
        <div v-if="donorDisposables && donorDisposables.length > 0" class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Name</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Batch/LOT Number</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Quantity</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Date Time</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Procedure</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Attendant</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(disposable, index) in donorDisposables" :key="index">
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ disposable.name || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ disposable.batch_number || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ disposable.quantity || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ disposable.date_time ? new Date(disposable.date_time).toLocaleString() : '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ disposable.procedure || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ getAttendantName(disposable.added_by) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-gray-500">No disposables recorded for this donor.</div>
      </div>

      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Vitals History</h2>

        <!-- Render table if donor vitals are present -->
        <div v-if="donor_vitals && donor_vitals.length > 0" class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y divide-gray-200 rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Date Recorded</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Linked Donation</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Weight</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Height</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Platelets Pre</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">RBC Pre</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Platelets Post</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">RBC Post</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Temperature</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Blood Pressure</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">HB Levels</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Pulse</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Yield</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Donor Attendant</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(vital, index) in donor_vitals" :key="index" :class="isPostDonationVitals(vital) ? 'bg-orange-100' : ''">
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ vital && vital.created_at ? new Date(vital.created_at).toLocaleString() : '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ getLinkedDonation(vital) }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.weight || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.height || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.platelets_pre_count || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.red_blood_cells_pre_count || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.platelets_post_count || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.red_blood_cells_post_count || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.temperature || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.blood_pressure || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.hb_levels || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.pulse || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ vital?.yield || '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ vital?.added_by?.first_name || '' }} {{ vital?.added_by?.last_name || '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No donor vitals available -->
        <div v-else-if="donor_vitals && donor_vitals.length === 0">
          No donor vitals history available.
        </div>

        <!-- Loading state -->
        <div v-else>Loading donor vitals history...</div>
      </div>

      <!-- edit button -->
      <div class="flex justify-end mt-6">
          <button class="flex justify-end px-4 py-2 font-bold text-white rounded bg-custom-yellow hover:bg-red-600"
            @click="handlePostDonationVitals">
            Add Post Donation Vitals
          </button>
      </div>

      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Deferral History</h2>

        <div v-if="deferrals && deferrals.length > 0" class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y divide-gray-200 rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Deferral date</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Deferral days</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Deferral hours</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Deferral reason</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Next donation date</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Donor Attendant</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(deferral, index) in deferrals" :key="index">
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ new
                  Date(deferral.created_at).toLocaleDateString("en-CA") ?? '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ deferral.deferral_days }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ deferral.deferral_hours }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ deferral.deferral_reason }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ deferral.next_donation_date ?? '' }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ deferral?.added_by?.first_name || '' }} {{ deferral?.added_by?.last_name || '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No reactions available -->
        <div v-else-if="deferrals && deferrals.length === 0">
          No Deferral history available.
        </div>

        <!-- Loading state -->
        <div v-else>Loading Deferral History details...</div>
      </div>


      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Referral History</h2>

        <!-- Render table if form_url are present -->
        <div v-if="form_url && form_url.length > 0" class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y divide-gray-200 rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Date Referred</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Donor Attendant</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Referred From</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Referred To</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Reason for Referral</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Uploaded File</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(referral, index) in form_url" :key="index">
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ new Date(referral.created_at).toLocaleDateString("en-CA") ?? '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ referral.created_by?.first_name || '' }} {{ referral.created_by?.last_name || '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ referral.facility_id?.name || '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ referral.referral_facility?.facility_name || '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  {{ referral.reason || '' }}
                </td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">
                  <div class="flex items-center space-x-2">
                    <span class="max-w-xs truncate">
                      {{ referral.form_url || 'No file' }}
                    </span>
                    <button v-if="referral.form_url" @click="openPreview(referral)"
                      class="px-3 py-1 text-sm text-blue-600 transition-colors border border-blue-600 rounded-md hover:text-blue-800 hover:bg-blue-50">
                      Preview
                    </button>

                    <!-- Modal for preview with larger size -->
                    <div v-if="showPreviewModal"
                      class="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-40">
                      <div class="bg-gray-500 p-6 rounded-lg shadow-lg w-full max-w-6xl h-[90vh] relative">
                        <button @click="closePreview" class="absolute text-xl top-2 right-2 text-gray-50">✕</button>
                        <iframe :src="selectedFile" class="w-full h-full"></iframe>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No form_url available -->
        <div v-else-if="form_url && form_url.length === 0">
          No referral history available.
        </div>

        <!-- Loading state -->
        <div v-else>Loading referral history details...</div>
      </div>


      <div class="mb-6">
        <h2 class="mb-4 text-xl font-semibold">Reactions History</h2>

        <div v-if="donation_reactions && donation_reactions.length > 0" class="overflow-x-auto">
          <table class="min-w-full border border-gray-200 divide-y divide-gray-200 rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Time of Reaction</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Donor HB</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Broad Reaction Type</th>
                <th class="px-6 py-3 text-xs tracking-wider text-left">Reaction Type</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(reaction, index) in donation_reactions" :key="index">
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ new
                  Date(reaction.time_of_reaction).toLocaleString("en-CA") }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ reaction.hb }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ reaction.reaction_broad_type }}</td>
                <td class="px-6 py-4 text-sm whitespace-nowrap">{{ reaction.reaction_type.join(', ') }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No reactions available -->
        <div v-else-if="donation_reactions && donation_reactions.length === 0">
          No reactions history available.
        </div>

        <!-- Loading state -->
        <div v-else>Loading Reactions History details...</div>
      </div>





      <div class="flex justify-between">
        <button class="px-4 py-2 text-orange-500 border border-orange-500 rounded">
          Back
        </button>
        <div>
          <button v-if="facility_code === 'TNH001'" class="px-4 py-2 mr-2 font-bold text-white bg-gray-500 rounded" @click="resendDonorToLabware(donor.donor_id)">
            Resend Donor
          </button>
          <button v-if="donor?.user?.blood_group_id && donor.user.blood_group_id.name !== 'Unknown' && donor.user.email" class="px-4 py-2 mr-2 font-bold text-white bg-gray-400 rounded" @click="sendCertificateEmail">
            Send Certificate
          </button>
          <button class="px-4 py-2 mr-2 font-bold text-white rounded bg-custom-yellow" @click="printDonorCertificate">
            Print Donor Certificate
          </button>
        </div>
      </div>
    </div>

    <!-- <component v-if="certificateComponent" :is="certificateComponent" ref="certificateComponent" :donor="donor"
      style="display: none"></component> -->

    <div v-if="showReferralPopup"
      class="fixed inset-0 flex items-center justify-center w-full h-full overflow-y-auto bg-gray-600 bg-opacity-50">
      <div class="bg-white p-8 rounded-lg shadow-xl w-[50rem]">
        <AlertLayout title="Reminders!" message="
        <ul>Only refer donors that need further medical assistance. View guiding document here.</ul>
      <ul>Kindly remember to enter brief reason for referral (optional)</ul>
      <ul>Kindly remember to upload supporting documents for referral (optional)</ul>
      <ul>Kindly note that donor will be immediately informed of their referral</ul>" type="warning" />
        <h2 class="mb-4 text-2xl font-bold">New Referral</h2>

        <!-- Align the button to the right and make it smaller -->
        <div class="flex justify-end mb-4">
          <button class="px-2 py-1 text-sm font-bold text-white rounded bg-custom-yellow hover:bg-orange-600"
            @click="handleNewFacility">
            + Add Referral Facility
          </button>
        </div>

        <form @submit.prevent="submitReferralForm" enctype="multipart/form-data">
          <div class="mb-4">
            <label class="block mb-2 text-md" for="facility">Referral Facility <span
                class="text-red-500">*</span></label>
            <select id="facility"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm placeholder-gray shadow-gray-400"
              v-model="referralForm.referral_facility_id" required>
              <option disabled value="">Select Facility</option>
              <option v-for="facility in facilities" :key="facility.id" :value="facility.id">
                {{ facility.facility_name }}
              </option>
            </select>
            <p v-if="error" class="text-red-500">{{ error }}</p>
          </div>

          <div class="mb-4">
            <label class="block mb-2 text-md" for="reason">Reason for Referral</label>
            <textarea id="reason" v-model="referralForm.reason"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm shadow-gray-400" required></textarea>
          </div>

          <!-- File Upload Fields -->
          <div class="mb-4">
            <label class="block mb-2 text-md">Upload Referral Documents</label>
            <input type="file" accept=".pdf" @change="handleFileUpload"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm shadow-gray-400">
          </div>

          <div class="flex justify-end space-x-2">
            <button type="button" @click="closeReferralPopup" class="px-4 py-2 text-gray-800 bg-gray-200 rounded">
              Cancel
            </button>
            <button type="submit" class="px-4 py-2 text-white rounded bg-custom-yellow">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="showVitalsPopup"
      class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75 backdrop-blur-sm">
      <div class="w-1/2 p-10 bg-white rounded-lg shadow-xl">
        <h2 class="mb-4 text-xl font-bold text-gray-600">Record post-donation vitals</h2>
        <form class="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div class="md:col-span-2">
            <label class="block mb-2 font-medium text-gray-700" for="blood_donation_id"
              >Select Donation <span class="text-red-500">*</span></label
            >
            <select
              id="blood_donation_id"
              v-model="vitalsFormData.blood_donation_id"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              @change="handleDonationSelect"
              required
            >
              <option value="" disabled selected>Select a donation</option>
              <option 
                v-for="donation in sortedDonations" 
                :key="donation.blood_donation_id" 
                :value="donation.blood_donation_id"
              >
                {{ formatDonationOption(donation) }}
              </option>
            </select>
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="weight"
              >Weight (Min: 50) <span class="text-red-500">*</span></label
            >
            <input
              id="weight"
              type="number"
              v-model="vitalsFormData.weight"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Weight"
              @blur="validateWeight"
              required
            />
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="height"
              >Height (cm)</label
            >
            <input
              id="height"
              type="number"
              v-model="vitalsFormData.height"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Height (cm)"
            />
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="hb_levels"
              >HB levels (Range: 12 - 19) <span class="text-red-500">*</span></label
            >
            <input
              id="hb_levels" 
              type="number"
              v-model="vitalsFormData.hb_levels"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="HB levels"
              @blur="validateHb"
              required
            />
          </div>

          <div v-if="showPlateletsPostCount">
            <label class="block mb-2 font-medium text-gray-700" for="platelets_post_count"
              >Platelets Post-Count</label
            >
            <input
              id="platelets_post_count"
              type="number"
              v-model="vitalsFormData.platelets_post_count"
              @input="calculateYield"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Platelets Post-Count"
            />
          </div>

          <div v-if="showRedBloodCellsPostCount">
            <label class="block mb-2 font-medium text-gray-700" for="red_blood_cells_post_count"
              >Red Blood Cells Post-Count</label
            >
            <input
              id="red_blood_cells_post_count"
              type="number"
              v-model="vitalsFormData.red_blood_cells_post_count"
              @input="calculateYield"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Red Blood Cells Post-Count"
            />
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="post_donation_volume"
              >Volume (ml)</label
            >
            <input
              id="post_donation_volume"
              type="number"
              v-model="vitalsFormData.post_donation_volume"
              @input="calculateYield"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Volume (ml)"
            />
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="yield"
              >Yield</label
            >
            <input
              id="yield"
              type="text"
              v-model="vitalsFormData.yield"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Yield (auto-calculated)"
              readonly
            />
          </div>

          <!-- <div>
            <label class="block mb-2 font-medium text-gray-700" for="donation_duration"
              >Donation Duration (minutes)</label
            >
            <input
              id="donation_duration"
              type="number"
              v-model="vitalsFormData.donation_duration"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Duration (minutes)"
            />
          </div> -->

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="temperature"
              >Temperature (Range: 35.0 - 38.0) <span class="text-red-500">*</span></label
            >
            <input
              id="temperature"
              type="number"
              v-model="vitalsFormData.temperature"
              step="0.1"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Temperature"
              @blur="validateTemperature"
              required
            />
          </div>

          <div>
            <label class="block mb-2 font-medium text-gray-700" for="pulse"
              >Pulse (Range: 60 - 100) <span class="text-red-500">*</span></label
            >
            <input
              id="pulse"
              type="number"
              v-model="vitalsFormData.pulse"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Pulse"
              @blur="validatePulse"
              required
            />
          </div>

          <div>
            <label
              class="block mb-2 font-medium text-gray-700"
              for="blood_pressure"
              >Blood Pressure (Range: 100-140 / 60-90) <span class="text-red-500">*</span></label
            >
            <input
              id="blood_pressure"
              type="text"
              v-model="vitalsFormData.blood_pressure"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              placeholder="Blood Pressure (e.g. 120/80)"
              @blur="validateBloodPressure"
              required
            />
          </div>

          <div>
            <label class="block mb-1" for="regularDonor"
              >Arm Inspection <span class="text-red-500">*</span></label
            >
            <div class="relative">
              <select
                id="regularDonor"
                class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
                v-model="vitalsFormData.arm_inspection"
                @change="validateArmInspection"
                required
              >
                <option value="" disabled selected>Select</option>
                <option value="pass">pass</option>
                <option value="fail">fail</option>
              </select>
              <div
                class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none"
              >
                <svg
                  class="w-4 h-4 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </form>
        <div class="flex justify-between mt-5 space-x-2">
          <button type="button" @click="closeVitalsPopup" class="px-4 py-1 text-gray-800 bg-gray-200 rounded">
            Close
          </button>
          <button type="button" class="px-4 py-1 text-white rounded bg-custom-yellow"
            @click="submitPostDonationVitals">
            submit
          </button>
        </div>
      </div>
    </div>

    <DonationTypeModal v-model="showDonationTypeModal" @proceed="handleDonationTypeSelection" />
    <StFrancisDonorCertificate v-if="donor" ref="stFrancisCertificate" :donor="donor" />

  </div>
</template>

<script>
import AlertLayout from "@/components/AlertLayout.vue";
import DonationTypeModal from '@/views/forms/DonationTypeModal.vue';
import api from "@/services/api";
import SweetAlertService from '@/services/SweetAlertService';
import AWS from 'aws-sdk';
import { useToast } from 'vue-toastification';
import StFrancisDonorCertificate from '@/components/StFrancisDonorCertificate.vue';


export default {
  name: "DonorDetailsPage",
  components: {
    AlertLayout,
    DonationTypeModal,
    StFrancisDonorCertificate,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      donor: null,
      error: null,
      donor_vitals: [],
      deferrals: [],
      referral: [],
      flags: [],
      donation_reactions: [],
      donorDisposables: [],
      inventoryRecords: [],
      disposablesFetched: false, // Flag to prevent duplicate requests
      showDeferralPopup: false,
      showReferralPopup: false,
      showDonationTypeModal: false,
      facilities: [],
      referralForm: {
        reason: "",
        facility_id: this.user().facility_id,
        referral_facility_id: "",
        form_url: "",
        created_by: this.user().user_id,
      },
      vitalsFormData: {
        blood_donation_id: "",
        donation_type: "",
        weight: "",
        height: "",
        hb_levels: "",
        platelets_post_count: "",
        red_blood_cells_post_count: "",
        post_donation_volume: "",
        yield: "",
        donation_duration: "",
        temperature: "",
        pulse: "",
        blood_pressure: "",
        arm_inspection: "",
      },
      uploadedFile: null,
      showPreviewModal: false,
      showVitalsPopup: false,
      selectedFile: null,
      facility_code: this.user().user_roles[0].facility_department.facility.facility_code
    };
  },
  mounted() {
    this.flags = this.$store.getters["auth/flags"];
  },
  created() {
    this.fetchDonorDetails().then(() => {
      // After donor details are loaded, fetch disposables and inventory
      this.fetchDonorDisposables();
      this.fetchInventoryRecords();
    });
    this.fetchDonorVitals();
    this.fetchDonationReactions();
    this.fetchDonorDeferrals();
    this.fetchDonorform_url();
    this.fetchFacilities();
  },

  watch: {
    donor: {
      handler() {
        if (this.donor && this.donor.blood_donations && this.donor.blood_donations.length > 0 && !this.disposablesFetched) {
          console.log("Donor data loaded, fetching disposables");
          this.fetchDonorDisposables();
        }
      },
      deep: true
    }
  },
  computed: {    
    sortedDonations() {
      if (!this.donor || !this.donor.blood_donations) return [];
      return this.donor.blood_donations.slice().sort((a, b) => {
        return new Date(b.date_added) - new Date(a.date_added); // Sort by descending order of date_added
      });
    },
    showPlateletsPostCount() {
      if (!this.vitalsFormData.donation_type) return true;
      const type = this.vitalsFormData.donation_type.toLowerCase() || '';
      return !type.includes('plasma') && !type.includes('red');
    },
    showRedBloodCellsPostCount() {
      if (!this.vitalsFormData.donation_type) return true;
      const type = this.vitalsFormData.donation_type.toLowerCase() || '';
      return !type.includes('platelet') && !type.includes('plasma');
    },
  },

  methods: {
    user() {
      return this.$store.getters["auth/user"];
    },

    getAttendantName(attendant) {
      if (!attendant) return '';
      return `${attendant.first_name || ''} ${attendant.last_name || ''}`.trim() || '';
    },

    isPostDonationVitals(vital) {
      if (!vital || !this.donor || !this.donor.blood_donations) return false;
      
      // If vitals has blood_donation_id, it's post-donation
      if (vital.blood_donation_id) return true;
      
      // If vitals has post-donation fields filled, consider it post-donation
      if (vital.platelets_post_count || vital.red_blood_cells_post_count || 
          vital.post_donation_volume || vital.yield || vital.donation_duration) return true;
      
      return false;
    },

    getLinkedDonation(vital) {
      if (!vital || !this.donor || !this.donor.blood_donations) return '';
      
      const vitalDate = vital.created_at ? new Date(vital.created_at) : null;
      if (!vitalDate) return '';
      
      // If vitals has blood_donation_id, find it directly
      if (vital.blood_donation_id) {
        const donation = this.sortedDonations.find(d => d.blood_donation_id === vital.blood_donation_id);
        if (donation) {
          const date = donation.date_added ? new Date(donation.date_added).toLocaleDateString() : '';
          const type = donation.technology || '';
          const serial = donation.pint_serial || '';
          return serial ? `${date} - ${type} (${serial})` : `${date} - ${type}`;
        }
      }
      
      // Otherwise, find closest donation before vitals date
      const donationsBefore = this.sortedDonations.filter(d => 
        d.date_added && new Date(d.date_added) <= vitalDate
      );
      
      if (donationsBefore.length > 0) {
        const closest = donationsBefore[0];
        const date = closest.date_added ? new Date(closest.date_added).toLocaleDateString() : '';
        const type = closest.donation_type || closest.technology || 'Unknown';
        const serial = closest.pint_serial || '';
        return serial ? `${date} - ${type} (${serial})` : `${date} - ${type}`;
      }
      
      return '';
    },

    getPostDonationVitals(donation) {
      if (!donation || !this.donor_vitals || this.donor_vitals.length === 0) return '';
      
      const donationDate = donation.date_added ? new Date(donation.date_added) : null;
      if (!donationDate) return '';
      
      // If donation has linked vitals via blood_donation_id
      if (donation.blood_donation_id) {
        const vital = this.donor_vitals.find(v => v.blood_donation_id === donation.blood_donation_id);
        if (vital && vital.created_at) {
          return new Date(vital.created_at).toLocaleDateString();
        }
      }
      
      // Find vitals recorded within a reasonable time after donation (same day or next day)
      const nextDay = new Date(donationDate);
      nextDay.setDate(nextDay.getDate() + 1);
      
      const vital = this.donor_vitals.find(v => 
        v.created_at && 
        new Date(v.created_at) >= donationDate &&
        new Date(v.created_at) <= nextDay
      );
      
      if (vital && vital.created_at) {
        return new Date(vital.created_at).toLocaleDateString();
      }
      
      return 'Not recorded';
    },

    getCollectionDeviceName(donation) {
      if (!donation || !donation.collection_device) return '';
      console.log("Looking for collection_device:", donation.collection_device, "in inventory:", this.inventoryRecords);
      const device = this.inventoryRecords?.find(item => item.id === donation.collection_device);
      return device ? device.item_name : donation.collection_device;
    },

    hasPostDonationVitals(donation) {
      if (!donation || !this.donor_vitals || this.donor_vitals.length === 0) return false;
      
      const donationDate = donation.date_added ? new Date(donation.date_added) : null;
      if (!donationDate) return false;
      
      // If donation has linked vitals via blood_donation_id
      if (donation.blood_donation_id) {
        return this.donor_vitals.some(v => v.blood_donation_id === donation.blood_donation_id);
      }
      
      // Check if vitals recorded within same day or next day
      const nextDay = new Date(donationDate);
      nextDay.setDate(nextDay.getDate() + 1);
      
      return this.donor_vitals.some(v => 
        v.created_at && 
        new Date(v.created_at) >= donationDate &&
        new Date(v.created_at) <= nextDay
      );
    },

    handleDonationSelect() {
      if (!this.vitalsFormData.blood_donation_id) return;
      const selectedDonation = this.sortedDonations.find(
        d => d.blood_donation_id === this.vitalsFormData.blood_donation_id
      );
      if (selectedDonation) {
        const donationDate = new Date(selectedDonation.date_added);
        const preVitals = this.donor_vitals
          .filter(v => v.created_at && new Date(v.created_at) < donationDate)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
        
        if (preVitals) {
          if (preVitals.weight) this.vitalsFormData.weight = preVitals.weight;
          if (preVitals.height) this.vitalsFormData.height = preVitals.height;
          
          if (selectedDonation.quantity) this.vitalsFormData.post_donation_volume = selectedDonation.quantity;
          
          if (preVitals.platelets_pre_count && preVitals.platelets_pre_count > 0) {
            this.vitalsFormData.donation_type = 'Platelets';
          } else if (preVitals.red_blood_cells_pre_count && preVitals.red_blood_cells_pre_count > 0) {
            this.vitalsFormData.donation_type = 'Red Blood Cells';
          } else {
            this.vitalsFormData.donation_type = selectedDonation.donation_type || selectedDonation.technology || '';
          }
        } else {
          this.vitalsFormData.donation_type = selectedDonation.donation_type || selectedDonation.technology || '';
        }
        
        if (selectedDonation.quantity) {
          this.vitalsFormData.post_donation_volume = selectedDonation.quantity;
        }
      }
      this.calculateYield();
    },

    formatDonationOption(donation) {
      const date = donation.date_added 
        ? new Date(donation.date_added).toLocaleDateString("en-CA")
        : '';
      const type = donation.donation_type || 'Unknown';
      const serial = donation.pint_serial || '';
      return serial ? `${date} - ${type} (${serial})` : `${date} - ${type}`;
    },

    calculateYield() {
      const plateletsPostCount = parseFloat(this.vitalsFormData.platelets_post_count) || 0;
      const redBloodCellsPostCount = parseFloat(this.vitalsFormData.red_blood_cells_post_count) || 0;
      const volume = parseFloat(this.vitalsFormData.post_donation_volume) || 0;
      
      if (volume > 0) {
        let yMicro = 0;
        if (plateletsPostCount > 0) {
          yMicro = plateletsPostCount;
        } else if (redBloodCellsPostCount > 0) {
          yMicro = redBloodCellsPostCount;
        }
        
        if (yMicro > 0) {
          const xMl = volume;
          const xMicro = xMl * 1000;
          const result = xMicro * yMicro;
          const scientific = result.toExponential(1);
          const formatted = scientific
            .replace('e+', ' × 10^')
            .replace('e', ' × 10^');
          this.vitalsFormData.yield = formatted;
        } else {
          this.vitalsFormData.yield = "";
        }
      } else {
        this.vitalsFormData.yield = "";
      }
    },

    async fetchDonorform_url() {
      try {
        const donorId = this.$route.params.donor_id;
        const response = await api.getDonorReferral(donorId);
        const data = response.data || response;

        // Assigning the fetched form_url directly to the form_url property
        this.form_url = data;

        // console.log("Fetching donor form_url", this.form_url);
      } catch (error) {
        this.error = error.message || "Failed to fetch donor form_url";
        console.error("Error fetching donor form_url:", this.error);
      }
    },

    openPreview(referral) {
      if (referral.form_url) {
        this.selectedFile = referral.form_url;
        this.showPreviewModal = true;
      } else {
        SweetAlertService.showError("Error", "No file available for preview");
      }
    },
    closePreview() {
      this.showPreviewModal = false;
      this.selectedFile = null;
    },

    handleFileUpload(event) {
            // Capture the selected file
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
            }
        },

        async uploadFile() {
            if (!this.selectedFile) {
                alert("No file selected.");
                return;
            }
            // Configure AWS SDK
            const s3 = new AWS.S3({
                endpoint: 'https://blr1.digitaloceanspaces.com', // Replace with your Spaces endpoint
                signatureVersion: 'v4',
                accessKeyId: 'DO00PK2KLQ4HUBKTB6R3',
                secretAccessKey: 'L3yOKmH3Dqfpc3tVZv4Mz5O+jd1bXTobKS//zmY72Rk',
                region: 'blr1',
            });

            const params = {
                Bucket: 'jiji-bucket', // Replace with your Space name
                Key: this.selectedFile.name,
                Body: this.selectedFile,
                ACL: 'public-read', // Make the file public if needed
                ContentType: this.selectedFile.type,
            };

            try {
                const result = await s3.upload(params).promise();
                console.log(result);

               if(result) {
                    this.toast.success('File uploaded successfully.');
                    return result.Location;
               }
            } catch (error) {
                this.toast.error('Unable to upload file, please check your internet connection.');
                return '';
            }
        },



    async submitReferralForm() {
      try {
        const donorId = this.$route.params.donor_id;

        if (this.selectedFile) {
                    const fileUrl = await this.uploadFile();
                    if (!fileUrl) {
                        this.isSubmitting = false;
                        return;
                    }
                    this.referralForm.form_url = fileUrl;
                }
        // Prepare payload with file name included if available
        const payload = {
          referral: {
            reason: this.referralForm.reason,
            referral_facility: this.referralForm.referral_facility_id,
            facility_id: this.referralForm.facility_id,
            created_by: this.referralForm.created_by,
            form_url: this.referralForm.form_url,
          },
        };

        // Send payload to API
        await api.createDonorReferral(donorId, payload);
        await SweetAlertService.showSuccess("Success!", "Referral saved successfully!");
        this.$router.push({ name: "DonorManagementPage" });

      } catch (error) {
        console.error("Error referring donor:", error);
        await SweetAlertService.showError("Error", "Error creating referral.");
      }
    },


    async fetchDonorDetails() {
      try {
        const donorId = this.$route.params.donor_id;
        const response = await api.getDonor(donorId);
        this.donor = response.data || response;
        // console.log("Fetched donor details:", this.donor);
      } catch (error) {
        this.error = error.message || "Failed to fetch donor details";
        console.error("Error fetching donor details:", this.error);
      }
    },


    async fetchDonorVitals() {
      try {
        const donorId = this.$route.params.donor_id;
        const response = await api.getDonorVital(donorId);
        console.log("API Response:", response);

        this.donor_vitals = response.data || response;

        console.log("Fetched donor vitals:", this.donor_vitals);
      } catch (error) {
        this.error = error.message || "Failed to fetch donor vitals";
        console.error("Error fetching donor vitals:", this.error);
      }
    },


    async fetchDonorDeferrals() {
      try {
        const donorId = this.$route.params.donor_id;
        const response = await api.getDonorDeferral(donorId);
        this.deferrals = response.data || response;


        console.log("Fetched donor vitals:", this.deferrals);
      } catch (error) {
        this.error = error.message || "Failed to fetch donor details";
        console.error("Error fetching donor details:", this.error);
      }
    },

    async fetchDonorDisposables() {
      try {
        // Prevent duplicate requests using flag
        if (this.disposablesFetched) {
          console.log("Disposables already fetched, skipping");
          return;
        }
        
        console.log("Fetching disposables, donor:", this.donor);
        // Only fetch if we have donor data with blood donations
        if (!this.donor || !this.donor.blood_donations || this.donor.blood_donations.length === 0) {
          console.log("No blood donations found for this donor yet, skipping disposables fetch");
          return;
        }
        
        // Use Promise.all for parallel fetching (much faster than sequential)
        const promises = this.donor.blood_donations.map(donation => {
          console.log("Fetching disposables for donation:", donation.blood_donation_id);
          return api.getDonationDisposables(donation.blood_donation_id)
            .then(response => {
              // Handle both wrapped and unwrapped responses
              const disposables = response?.data || response || [];
              console.log("Disposables for donation", donation.blood_donation_id, ":", disposables);
              return disposables;
            })
            .catch(err => {
              console.error("Error fetching disposables for donation", donation.blood_donation_id, ":", err);
              return [];
            });
        });
        
        // Wait for all requests to complete
        const results = await Promise.all(promises);
        
        // Flatten all results into a single array
        const allDisposables = results.flat();
        this.donorDisposables = allDisposables;
        this.disposablesFetched = true; // Mark as fetched to prevent duplicate requests
        console.log("All disposables:", this.donorDisposables);
      } catch (error) {
        console.error("Error fetching donor disposables:", error);
        this.donorDisposables = [];
      }
    },

    async fetchInventoryRecords() {
      try {
        const response = await api.getInventoryRecords();
        if (Array.isArray(response)) {
          this.inventoryRecords = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.inventoryRecords = response.data;
        } else {
          this.inventoryRecords = [];
        }
        console.log("Inventory records loaded:", this.inventoryRecords.length);
      } catch (error) {
        console.error("Error fetching inventory records:", error);
        this.inventoryRecords = [];
      }
    },

    async fetchDonationReactions() {
      try {
        const donorId = this.$route.params.donor_id;
        const response = await api.getAllDonationReactionsForDonor(donorId);
        const data = response.data || response;
        this.donation_reactions = data.donation_reactions
        console.log("Fetcnhing donor reactions", this.donation_reactions);
      } catch (error) {
        this.error = error.message || "Failed to fetch donor details";
        console.error("Error fetching donor details:", this.error);
      }
    },

    handleEditDonorInfo() {
      this.$router.push({
        name: "EditDonorInformationPage",
        params: { donor_id: this.$route.params.donor_id },
      });
    },

    handlePostDonationVitals() {
      this.vitalsFormData = {
        blood_donation_id: "",
        donation_type: "",
        weight: "",
        height: "",
        hb_levels: "",
        platelets_post_count: "",
        red_blood_cells_post_count: "",
        post_donation_volume: "",
        yield: "",
        donation_duration: "",
        temperature: "",
        pulse: "",
        blood_pressure: "",
        arm_inspection: "",
      };
      this.showVitalsPopup = true;
    },

    closeVitalsPopup() {
      this.showVitalsPopup = false;
    },

    async submitPostDonationVitals() {
      try {
        const donorId = this.$route.params.donor_id;
        const bloodPressure = this.vitalsFormData.blood_pressure;

        // Extract systolic and diastolic values
        const [systolic, diastolic] = bloodPressure.split("/").map(Number);

        // Combine formData with additional fields like added_by
        const payload = {
          donor_vital: {
            ...this.vitalsFormData,
            systolic: systolic, // Send systolic value separately
            diastolic: diastolic, // Send diastolic value separately
            added_by: this.user().user_id,
          }
        };

        const response = await api.createDonorVital(donorId, payload);
        console.log("Donor vitals saved successfully:", response);
        await SweetAlertService.showSuccess(
          "Success!",
          "Donor vitals added successfully!."
        );
        this.showVitalsPopup = false;
        this.$router.go(0);
      } catch (error) {
        console.error("Error submitting the form:", error);
        SweetAlertService.showError(
          "Error",
          "Something went wrong while saving donor vitals."
        );
      }
    },

    redirectToVitalsForm() {
      this.showDonationTypeModal = true;
    },

    handleDonationTypeSelection(type) {
      this.showDonationTypeModal = false;
      const donorId = this.$route.params.donor_id;
      if (type === 'normal') {
        this.$router.push({
          name: 'NewDonorVitalsForm',
          params: { donor_id: donorId }
        });
      } else if (type === 'apheresis') {
        this.$router.push({
          name: 'NewApheresisScreeningForm',
          params: { donor_id: donorId }
        });
      }
    },

    redirectToDeferralForm() {
      this.$router.push({
        name: 'NewDonorDeferralForm',
        params: { donor_id: this.$route.params.donor_id }
      });
    },

    redirectToDonationReactionForm() {
      this.$router.push({
        name: 'NewReactionForm',
        params: { donor_id: this.$route.params.donor_id }
      });
    },

    openReferralPopup() {
      this.referralForm.donor_id = parseInt(this.$route.params.donor_id, 10);
      this.showReferralPopup = true;
    },

    closeReferralPopup() {
      this.showReferralPopup = false;
      this.referralForm = {
        reason: "",
        referral_facility: "",

      };
    },

    // handleNewFacility() {
    //   this.$router.push({ name: 'NewReferralFacilityForm' });
    // },


    handleNewFacility() {
      this.$router.push({
        name: 'NewReferralFacilityForm',
        params: { donor_id: this.$route.params.donor_id }
      });
    },

    async fetchFacilities() {
      try {
        const response = await api.getReferralFacilities();
        this.facilities = response.data || response;
      } catch (error) {
        this.error = error.message || "Failed to fetch facilities";
      }
    },

    calculateDeferralDays(dateAdded, nextDonationDate) {
      if (dateAdded && nextDonationDate) {
        const dateAddedObj = new Date(dateAdded);
        const nextDonationDateObj = new Date(nextDonationDate);
        const diffTime = Math.abs(nextDonationDateObj - dateAddedObj);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
        return diffDays;
      }
      return '';
    },

    async resendDonorToLabware(donor_id){
      try{
        const payload = {
          donor_id: donor_id
        }
        await api.resendDonorTNH(payload);
        SweetAlertService.showSuccess(
            "Confirmation Recorded",
            `Donor resend to labware successfully`
          );
      } catch (error) {
        console.error("Error resending donor", error);
        SweetAlertService.showError("Error", "Error resending donor.");
      }
    },


    printDonorCertificate() {
      if (this.facility_code === 'SFCH001') {
        this.$refs.stFrancisCertificate?.printStFrancisDonorCertificate();
        return;
      }
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      document.body.appendChild(printWindow);

      // Fetch donor data
      const donorName = `${this.donor?.user?.first_name ?? ''} ${this.donor?.user?.last_name ?? ''}`;
      const donorBloodGroup = this.donor?.user?.blood_group_id?.name ?? 'Unknown';
      const registrationDate =  new Date(this.donor.created_at).toLocaleDateString("en-CA")
      const phoneNumber = this.donor.user.phone_number;
      const salutation = this.donor.user.gender

      const hasTnhCertificate = this.facility_code === 'TNH001';
      // const hasAARCertificate = flagsArray.some(flag => flag === "Porter Name Aar");
      const backgroundImageClass = hasTnhCertificate ? 'tnh_background-image' :
                                   // hasAARCertificate ? 'aar_background-image' :
                                   'general_background-image';



      // Get the full absolute URL for the images
      const baseUrl = window.location.origin;

      const extraItems = !hasTnhCertificate ? `
    <!-- Phone Number -->
    <div class="credits-text phone">
      ${phoneNumber}
    </div>
    <!-- Last Donation Date -->
    <div class="credits-text salutation">
      ${salutation}
    </div>
    <div class="credits-text blood_group_gen">
      ${donorBloodGroup}
    </div>
  ` : '';

      const tnhContent = hasTnhCertificate ? `
  <!-- Registration Date -->
  <div class="credits-text reg_date">
    ${registrationDate}
  </div>
    <!-- Blood Group -->
        <div class="credits-text blood_group_tnh">
          ${donorBloodGroup}
        </div>
` : '';

      const printContent = `
    <div class="print-container">
      <div class="${backgroundImageClass}">
        <!-- Name -->
        <div class="cert-text donor_names">
          <b>${donorName}</b>
        </div>



          </div>
          ${tnhContent}
        ${extraItems}
      </div>

      </div>
    </div>
  `;

      const printDocument = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Print Preview</title>
      <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: landscape;
          margin: 0;
        }

        html {
          margin: 0;
          padding: 0;
          height: 100%;
        }

        body {
          margin: 0;
          padding: 0;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #555555;
        }

        .print-container {
          width: 100%;
          height: 100vh;
          position: relative;
          overflow: hidden;
        }

        .tnh_background-image,
        .general_background-image {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .tnh_background-image {
          background-image: url('${baseUrl}/TNH-cert-front.png');
        }

        .aar_background-image {
          background-image: url('${baseUrl}/aar.png');
        }

        .general_background-image {
          background-image: url('${baseUrl}/JijiHealthCert.jpg');
        }

        .cert-text, .credits-text {
          font-family: serif;
          color: #555555;
          font-weight: bold;
          position: absolute;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .cert-text.donor_names {
          top: 49%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 24pt;
          font-family: 'Dancing Script', cursive;
          width: 80%;
          text-align: center;
        }

        .credits-text.blood_group_tnh {
          top: 63%;
          left: 30%;
          font-size: 18pt;
          font-family: 'Dancing Script', cursive;
        }

         .credits-text.blood_group_gen {
          top: 57%;
          left: 29%;
          font-size: 18pt;
          font-family: 'Dancing Script', cursive;
        }

        .credits-text.reg_date {
          top: 63%;
          right: 35%;
          font-size: 18pt;
          font-family: 'Dancing Script', cursive;
        }

        .credits-text.phone {
          top: 68%;
          left: 27%;
          font-size: 18pt;
          font-family: 'Dancing Script', cursive;
        }

        .credits-text.salutation {
          top: 57%;
          left: 57%;
          font-size: 18pt;
          font-family: 'Dancing Script', cursive;
        }

        @media print {
          @page {
            size: landscape;
          }

          html {
            height: 100%;
          }

          body {
            height: 100vh;
            margin: 0;
            padding: 0;
          }

          .print-container {
            height: 100vh;
            page-break-after: avoid;
            page-break-before: avoid;
          }

          .cert-text, .credits-text {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }
        }
      </style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `;

      // Write to iframe and print
      printWindow.contentDocument.open();
      printWindow.contentDocument.write(printDocument);
      printWindow.contentDocument.close();

      // Wait for images to load before printing
      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.contentWindow.print();
          // Remove the iframe after printing
          setTimeout(() => {
            document.body.removeChild(printWindow);
          }, 1000);
        }, 1000); // Add a delay to ensure styles are applied
      };
    },

    async sendCertificateEmail() {
      try {
        const donorId = this.$route.params.donor_id;
        await api.sendCertificateEmail(donorId);
        await SweetAlertService.showSuccess("Success!", "Certificate email sent successfully!");
      } catch (error) {
        console.error("Error sending certificate email:", error);
        SweetAlertService.showError("Error", "Failed to send certificate email.");
      }
    }

  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

/* Donation Type Modal */
.donation-type-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.donation-type-content {
  background: white;
  padding: 2rem;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 28rem;
}

.donation-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.donation-type-option {
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
}

.donation-type-option.selected {
  border-color: #f97316;
  box-shadow: 0 0 0 2px #f9731633;
}

.donation-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.75rem;
  background-color: #f3f4f6;
  border-radius: 9999px;
}

.donation-type-label {
  font-size: 1rem;
  font-weight: 600;
}

.donation-type-desc {
  font-size: 0.875rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

.donation-type-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.donation-type-cancel {
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
}

.donation-type-proceed {
  padding: 0.5rem 1rem;
  background-color: #f97316;
  color: white;
  border-radius: 0.25rem;
}

.donation-type-proceed:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* .details-card {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  background-color: #f9f9f9;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  align-items: center;
} */

.detail {
  margin-bottom: 10px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
  color: black;
}

.value {
  color: #333;

}
</style>
